export const ODDS_FORMAT = {
  AMERICAN: 'american',
  DECIMAL: 'decimal',
  FRACTIONAL: 'fractional',
  TRADITIONAL: 'traditional',
} as const;

export type OddsFormat = (typeof ODDS_FORMAT)[keyof typeof ODDS_FORMAT];

export const getOddsFormatIs = (userOddsFormat: OddsFormat) => ({
  American: userOddsFormat === ODDS_FORMAT.AMERICAN,
  Decimal: userOddsFormat === ODDS_FORMAT.DECIMAL,
  Fractional: userOddsFormat === ODDS_FORMAT.FRACTIONAL,
});
